import { memo, useState } from "react";

type MenuTabProps = {
    currentValue: (value: number) => void;
};

function MenuTab({ currentValue }: MenuTabProps) {
    const [value, setValue] = useState<number>(1);
    const handleChangeValue = (newValue: number) => {
        setValue(newValue);
        currentValue(newValue);
    };

    return (<div className="w-full">
        <div className="border-b-[2px] border-black w-full">
            <div>
                <span className={`rounded-t-[4px] border-t-[2px] border-l-[2px] border-r-[2px] border-black hover:bg-[rgba(0,0,0,0.2)] border-b-none py-[2px] px-[8px] cursor-pointer ${value === 1 ? 'bg-black' : ''}`} onClick={() => handleChangeValue(1)}>Chi nhánh</span>
                <span className={`rounded-t-[4px] border-t-[2px] border-l-[2px] border-r-[2px] border-black hover:bg-[rgba(0,0,0,0.2)] border-b-none py-[2px] px-[8px] cursor-pointer ml-[1px] ${value === 2 ? 'bg-black' : ''}`} onClick={() => handleChangeValue(2)}>Khóa học</span>
                <span className={`rounded-t-[4px] border-t-[2px] border-l-[2px] border-r-[2px] border-black hover:bg-[rgba(0,0,0,0.2)] border-b-none py-[2px] px-[8px] cursor-pointer ml-[1px] ${value === 3 ? 'bg-black' : ''}`} onClick={() => handleChangeValue(3)}>Môn học</span>
            </div>
        </div>
    </div>);
}

export default memo(MenuTab);